import React from "react";
import { IconButton, Tooltip, makeStyles } from "@material-ui/core";
import { Brightness4, Brightness7 } from "@material-ui/icons";
import { useThemeMode } from "../context/ThemeContext";
import { useTranslation } from "../hooks/useTranslation";

const useStyles = makeStyles(() => ({
  headerButton: {
    color: "var(--ikaro-text-white)",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.1)",
    },
  },
  loginButton: {
    color: "var(--ikaro-gray-dark)",
    backgroundColor: "var(--ikaro-bg-surface)",
    border: "1px solid var(--ikaro-gray-medium)",
    "&:hover": {
      backgroundColor: "var(--ikaro-bg-surface-hover)",
    },
  },
}));

function ThemeSelector({ variant = "header" }) {
  const classes = useStyles();
  const { t } = useTranslation("common");
  const { isDark, toggleTheme } = useThemeMode();

  const isLogin = variant === "login";
  const tooltipText = isDark
    ? t("common:theme.switchToLight") || "Tema claro"
    : t("common:theme.switchToDark") || "Tema escuro";

  return (
    <Tooltip title={tooltipText} arrow placement="bottom">
      <IconButton
        className={isLogin ? classes.loginButton : classes.headerButton}
        onClick={toggleTheme}
        aria-label={tooltipText}
      >
        {isDark ? <Brightness7 /> : <Brightness4 />}
      </IconButton>
    </Tooltip>
  );
}

export default ThemeSelector;
